import ActionsList from 'front-office/components/registration-id-card/actions-list';
import { RegisterIdCardSearchPersonCrumbs } from 'front-office/constants/register-id-card-crumbs';
import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import PersonSearch from 'shell/components/shared/person-search';

const RegisterIdCardSearchPersonPage = (): React.ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={RegisterIdCardSearchPersonCrumbs} />
      <PersonSearch
        pathname="/sportello/registrazione-carta/registra"
        action={ActionsList}
        addedTitle="- Registrazione Carta Identità"
      />
    </Fragment>
  );
};

RegisterIdCardSearchPersonPage.displayName = 'Register id card search person page component';

export default RegisterIdCardSearchPersonPage;
